export default "__VITE_ASSET__Dshe9yyi__"